import { consumerApi } from '@api/consumer/consumer.api';

export const {
  useLazyLoadConsumersQuery,
  useAddConsumerMutation,
  useLazyGetAccessTokenQuery,
  useDeleteConsumerMutation,
  useLazyLoadLimitConsumersQuery,
} = consumerApi;
